import gql from 'graphql-tag';


export default gql`query loggedInUser {
    loggedInUser {
        id
    }
}`



// WEBPACK FOOTER //
// ./src/graphql/queries/loggedInUser.query.js